import styled from 'styled-components';
import { Checkmark } from '@carvana/icons';

export const CheckmarkIcon = styled(Checkmark)`
  color: ${(props: any) => props.theme.carvana.blue.primary};
  display: flex;
  align-items: center;
  justify-content: center;
  width: 12px;
  height: 10px;
  opacity: 0;
  transition: opacity 150ms ease-out;

  &.is-checked {
    opacity: 1;
  }
`;

export const Label = styled.label`
  color: ${(props: any) => props.theme.carvana.blue.primary};
  background: ${(props: any) => props.theme.carvana.white.primary};
  border: 1px solid ${(props: any) => props.theme.carvana.gray.light};
  border-radius: 3px;
  width: 25px;
  height: 25px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: border 150ms ease-out;
  :hover {
    border: 1px solid ${(props: any) => props.theme.carvana.blue.hover};
    svg {
      color: ${(props: any) => props.theme.carvana.blue.hover};
    }
  }
  &.is-checked {
    border: 1px solid ${(props: any) => props.theme.carvana.blue.primary};
  }
`;

export const Input = styled.input`
  opacity: 0;
  width: 0;
  height: 0;
`;
